"use client";
import type React from "react";
import { useState } from "react";
import { useApp } from "@/forApp/states/appState/appState";
import Tabs, { type TabItem } from "@/shared/Tabs/Tabs";
import AgencyRegister from "./AgencyRegister";
import AgentRegister from "./AgentRegister";
import styles from "./styles.module.css";
import UserRegister from "./UserRegister";

const tabs: TabItem[] = [
	{ title: "Физическое лицо", value: "user" },
	{ title: "Администратор агентства", value: "agency" },
	{ title: "Частный агент", value: "agent" },
];

const Register: React.FC = () => {
	const [activeTab, setActiveTab] = useState("user");
	const { isMobile } = useApp();
	return (
		<div className={styles.loginForm}>
			<Tabs
				tabs={tabs}
				activeTab={activeTab}
				onTabChange={(value) => setActiveTab(value)}
				variant={"entity-selector"}
				className={isMobile ? styles.mobileTabs : styles.tabs}
				isMobile={isMobile}
			/>
			{activeTab === "user" && <UserRegister />}
			{activeTab === "agency" && <AgencyRegister />}
			{activeTab === "agent" && <AgentRegister />}
		</div>
	);
};

export default Register;
